import { Component } from "react";
import Arweave from "arweave";
import { Button, Card } from "react-bootstrap";
import { readContract } from 'smartweave'
import AmaQuestionForm from "./ama_question_form";
import ReactTooltip from "react-tooltip"
import Ama from "./ama.jsx"

const arweave = Arweave.init({
  host: "arweave.net",
  port: 443,
  protocol: "https",
  timeout: 100000,
  logging: false,
});

///LIe23dId6NpmjC90-Ub81t2qYlaADQY5wxuf6zfshYc - below
// 03cJff2FSJroUce4E5FBsMJ0wkHJSBd24oYBw_dkNUk
const amaContractId = '03cJff2FSJroUce4E5FBsMJ0wkHJSBd24oYBw_dkNUk'

const samAma = {

  "guest": "SamWilliams",
  "archived": true,
  "endOn": 729532,
  "reward": 10,
  "guestAddress": "vLRHFqCw1uHu75xqB4fCDW-QxpkpJxBtFD9g4QYUbfw",
  "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY",
  "description": "Arweave founder & CEO",
  "questions": [
    {
      "QID": "VSiQBgnDwjQDek0JlXpWgKyfNhB8CyipaknmJQpp3lk",
      "question": "Do you think the there's a chance arweave can surpass etherium in value and adoption in the future?",
      "asker": "kks7s-kx6lPdZzl6NSYZQDB76NNFBgmGN5EDZ874fYQ",
      "atBlockheight": 726079,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "BpXfcPkN10o4bqbtDH-cceOL3E7CM0NccYFbNcI-Yxc",
      "question": "what is the plan for engaging more people and letting more people know about arweave?     ",
      "asker": "F3f9v0DHJy0yb8P0o0GD3z1o1-umlItLi3wlD2WoDNc",
      "atBlockheight": 726508,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "uaof1SVLvTclMIxNZ24WF0vGRcSd_sK4-4qqF2dfRVc",
      "question": "hi sam What do you think of the storage computing paradigm？Could ARWEAVE replace Ethereum?",
      "asker": "OVykQflMMLIRD-GvWUOX6rGUw_RNhDD0eXf9quwzJjk",
      "atBlockheight": 726593,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "f8kzcdWXtmnPVfAnRzzkmAC19EcmlwmIc77bXGALXu4",
      "question": "What do you think of Arweve's future mass adoption scenarios",
      "asker": "OVykQflMMLIRD-GvWUOX6rGUw_RNhDD0eXf9quwzJjk",
      "atBlockheight": 726607,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "xNgx50z_gmU4A7cqIWEx-etqniFw-qkvKNcG2v3Er80",
      "question": "Going forward, do you foresee any major changes being made to the Arweave protocol itself, or is it considered 'done'?",
      "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
      "atBlockheight": 727516,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    }
  ],
  "answers": [
    {
      "answerTo": "VSiQBgnDwjQDek0JlXpWgKyfNhB8CyipaknmJQpp3lk",
      "answer": "It's not my place to speculate on prices. In general, though, I think that the value captured by the base layer of the decentralised web could be enormous.",
      "answerTXID": "qgTZtkrcrUY-kue_6lX7ypplyua7d8O15gMti4jkIE8",
      "atBlockheight": 727920,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "BpXfcPkN10o4bqbtDH-cceOL3E7CM0NccYFbNcI-Yxc",
      "answer": "Through building a decentralised marketing infrastructure -- including backing initiatives just like this! Arweave.News now has an incredible full-time team working on producing interesting content around the permaweb ecosystem -- and they are not alone. @OnlyArweave is also starting up a vehicle to focus on getting the word out and pushing Arweave adoption (more on this, soon). On top of that, as we on-board more founders and projects to the ecosystem, they too become heavy transmitters of the 'meme'.",
      "answerTXID": "uTUaQ-3Gkc6FfBmbqmOPA7Uk2ZzOldHcrTaZyNGJLyA",
      "atBlockheight": 727924,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "uaof1SVLvTclMIxNZ24WF0vGRcSd_sK4-4qqF2dfRVc",
      "answer": "It is pretty fascinating! It seems obvious that the key to smart contract scalability is about data availability -- transaction execution is actually an easier and simpler game. @outprog from EverFinance was one of the first to realise this, and wrote it up into an incredible article. It is definitely worth a look.",
      "answerTXID": "GGj41d_wmBD9h6QsFovm-Z3i313GX7FGtmQ3wfLkWF4",
      "atBlockheight": 727925,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "f8kzcdWXtmnPVfAnRzzkmAC19EcmlwmIc77bXGALXu4",
      "answer": "I think the game is to build a new, better web. A good-case outcome for us is to essentially become embedded as the shared knowledge layer of humanity, as well as the core application hosting platform.\n\nIt's early days and it is an exceptionally large goal, but if you had told us 4 years ago where we are today we would not have believed that was possible, either :).",
      "answerTXID": "TuQFYV9ewxgs83rtr9p3-xEd0imBtBZ_QuKpLF7Of9c",
      "atBlockheight": 727930,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "xNgx50z_gmU4A7cqIWEx-etqniFw-qkvKNcG2v3Er80",
      "answer": "Interesting question! I think we are on the exponentially decaying curve of changes now. There are still things that we are tweaking, but the broad principles of the Arweave protocol are now locked in place and (mostly) battle-tested. I expect the core protocol changes to continue getting smaller over time.\n\nMuch of the key ecosystem development nowadays is being led by the community in the protocols on top of Arweave core -- work on SmartWeave, bundling, gateways, verified archivers, and much more, are all being spearheaded by the community itself.",
      "answerTXID": "O0qGZvK8wdZHH4LP4eN4gdOpSRvNQmXWajOi3O1Pgqg",
      "atBlockheight": 727932,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
  ]
}

const tateAma = {
  "guest": "Tate Berenbaum",
  "endOn": 739913,
  "reward": 10,
  "guestAddress": "pvPWBZ8A5HLpGSEfhEmK1A3PfMgB_an8vVS6L14Hsls",
  "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y",
  "description": "Founder @ Verto & nest.land",
  "questions": [
    {
      "QID": "IOPewn0msLukJfFf07jmYnk9llGM2M8M4mAMrJD3SR8",
      "question": "Can you give us a sneak peak into the roadmap? What is in store for Verto's future?!",
      "asker": "cmB3r44wI1iiGdm8M1dVTv3LFWT5UkAO5B8L5klyvVE",
      "atBlockheight": 733588,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "QID": "fITa8X5-HQQstQ5CwTjjD4qc4dmxDw2l-S67wbnNuSs",
      "question": "What are your favorite projects (outside of Verto) in the Arweave ecosystem?",
      "asker": "cmB3r44wI1iiGdm8M1dVTv3LFWT5UkAO5B8L5klyvVE",
      "atBlockheight": 733588,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "QID": "RDsileoSdSmGGpsRyFcHWc_pAFe7HdZ9v5tiZsu7IN4",
      "question": "What is the biggest pain point currently within the Arweave ecosystem and where/what would you encourage new founders to spend their time building?",
      "asker": "cmB3r44wI1iiGdm8M1dVTv3LFWT5UkAO5B8L5klyvVE",
      "atBlockheight": 733591,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "QID": "qMrsMJV09Y_NGyN0XEwor00zlZ551CKyaoFf3H-_578",
      "question": "Are you part of any PSCs or DAOs outside or the Arweave ecosystem? A lot of your work focuses on Arweave PSTs - what is exciting specifically about these?",
      "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
      "atBlockheight": 736164,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "QID": "Yw4Pw4haRUxqx7cZvDwP-b4Fhhkzm-vyIU3zE6xxgG4",
      "question": "What is @moreverto? 👀",
      "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
      "atBlockheight": 736164,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    }
  ],
  "answers": [
    {
      "answerTo": "IOPewn0msLukJfFf07jmYnk9llGM2M8M4mAMrJD3SR8",
      "answer": "In the next 6 months, we're looking to advance our UI/UX and begin a pivot towards a noncustodial, SmartWeave contract-based solution for the Verto protocol. You can expect a brand new UI launch on Verto.exchange very soon, and we'll then finish updating ArConnect with Ledger support after that. \n\nOur team is going to be releasing some more in-depth material covering this in the near future, so stay tuned!",
      "answerTXID": "su5AuSWPXjU9Z1MEflv7QNrDk73waN7y8uE6_hg7jWQ",
      "atBlockheight": 736698,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "answerTo": "fITa8X5-HQQstQ5CwTjjD4qc4dmxDw2l-S67wbnNuSs",
      "answer": "This is a tough question! There are so many incredible people starting incredible projects in the space. Though I can't pick any favorites, I can say with certainty that I am most inspired by the new teams coming into the ecosystem with a goal of collaborating with as many people and protocols as possible. \n\nI don't mean to sound like a broken record, but the composability in this ecosystem is truly unique. Building lego bricks for others to integrate into their own protocols is both attractive from a community/collaboration standpoint and a value proposition standpoint. We as a community have a massive opportunity here.",
      "answerTXID": "qVKFJNZJF7af_sGfF020sXCyIkhig7Sh6uLGEJtdPAA",
      "atBlockheight": 736703,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "answerTo": "RDsileoSdSmGGpsRyFcHWc_pAFe7HdZ9v5tiZsu7IN4",
      "answer": "Two of the current largest ecosystem pain points (in my opinion) are developer documentation and ease of access to navigating the project/protocols on the permaweb. I believe these are very temporary, but I think all teams could make it a goal to improve their documentation. This especially applies to Verto and ArConnect's JS libraries, so we'll be working on this too! \n\nI somewhat addressed the second part of this question in a previous response, but I am actively encouraging people to find and spend time building lego bricks for others to use in their protocols. Besides that, if you can find a way to align an opportunity in this space with your passion, go for it!",
      "answerTXID": "4AnIHlzS9jfUwFHTLObjOYBlAaLJwdviXqu9IoucjKo",
      "atBlockheight": 736733,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "answerTo": "qMrsMJV09Y_NGyN0XEwor00zlZ551CKyaoFf3H-_578",
      "answer": "At the time of writing this, I am not involved in any DAOs outside of the Arweave ecosystem. My focus lies here! I feel that profit-sharing tokens open the gates for many interesting and novel mechanism designs and use-cases for decentralized technology. I don't want to spoil too much soon to come, but we're going to be seeing several new teams and protocols that specifically utilize the profit-sharing aspect of *other* tokens in the space here. :)",
      "answerTXID": "TfcrIa_WkwJOW4mBS1PbGczNaOGW6Op4KQClBvPQQng",
      "atBlockheight": 736739,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    },
    {
      "answerTo": "Yw4Pw4haRUxqx7cZvDwP-b4Fhhkzm-vyIU3zE6xxgG4",
      "answer": "The @moreverto Twitter account is going to be used from now on to show daily updates on UI/UX/bugs/protocol modifications in a less formal, more granular fashion. We want to be as transparent as possible as our roadmap and thinking continue to evolve, so the @moreverto account will be here to document these types of topics too. ",
      "answerTXID": "VDcguTnIC3gJl634U0Sk0ijAj1nNsFlds0WDgOfxOR4",
      "atBlockheight": 736739,
      "id": "M15tRayDpw0z3c1IpMmheEw_bxPCV1pWii6R7UguY_Y"
    }
  ]
}

const kyveAma = {
  "guest": "Fabian Riewe & John Letey",
      "endOn": 744772,
      "reward": 10,
      "guestAddress": "Cs2aFNYV9LcE9LDRYMOo3iYlCMv1CHqv43gpUST0lPs",
      "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ",
      "description": "Founders @ KYVE",
      "questions": [
        {
          "QID": "5YRqJcMghX1aziSNQraNoYZrhjAzwbOxswTS4emgWyU",
          "question": "how about the use and release time of kyve tokens ? can you give a detail ? thanks",
          "asker": "M48Olo3zD3Ft_So5hm8-iepL6LspQB6CAhDk0ycCCQo",
          "atBlockheight": 740451,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "QID": "9QAp_T36fi-kBIHRl5xdSjMT4KGHyEiWSJs1VLw291c",
          "question": "Can you ELI5 KYVE?",
          "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
          "atBlockheight": 740973,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "QID": "su2ltjJvc62jeVfbw7s-M8yAqDLB1gSlcRL6PkUAfRc",
          "question": "What are the most exciting future use cases you see KYVE enabling?",
          "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
          "atBlockheight": 742437,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "QID": "bjwmCMqrwiF1Ql9pAVj6AeAGCVHTWQnQWo6CcZswRGM",
          "question": "Can you give some background on what sparked the idea to build KYVE, and why?",
          "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
          "atBlockheight": 742437,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "QID": "ios0UNtRKai8QW_yn1VowKwAztsEf7qtj9iAsUtH0Ss",
          "question": "KYVE archives historical data from Solana and other chains. What do you see this being used for and what are the benefits to pull it from KYVE vs Solana?",
          "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
          "atBlockheight": 743590,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "QID": "vQNV1F0z-OtCyb6pgnBIZfKwINCCNcekwZrq9E--I5Y",
          "question": "What are your plans for 2k21 in terms of data science with the data of your backers?",
          "asker": "Ex5WxelNLFnXx0MmL4N6F3pnv1A9VN-W0u3S1JZAqwc",
          "atBlockheight": 743938,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        }
      ],
      "answers": [
        {
          "answerTo": "bjwmCMqrwiF1Ql9pAVj6AeAGCVHTWQnQWo6CcZswRGM",
          "answer": "Previously, John and Fabian had worked together on ArVerify. One weekend in February, they stumbled upon a Gitcoin bounty (https://gitcoin.co/issue/ArweaveTeam/Bounties/41/100024675) to archive Polkadot data on Arweave. They then created a simple script for the bounty. After talking to other major L1s, they realized this was a needed solution and decided to generalize and expand on the script, turning it into an incentivized network of nodes.",
          "answerTXID": "0dcTfzkF30GLS18xo9xyfKsXYu_54YVdbjvzzFFbkRw",
          "atBlockheight": 744644,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "answerTo": "5YRqJcMghX1aziSNQraNoYZrhjAzwbOxswTS4emgWyU",
          "answer": "As of right now, we’re still on testnet. Hopefully, we can share more about our token as we get closer to our mainnet launch! You can get free testnet tokens here: https://www.kyve.network/faucet.",
          "answerTXID": "jxf9I9Ov_rxoHrADu9n7GJmCaPibv2loMZ_dBDjpkVU",
          "atBlockheight": 744648,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "answerTo": "vQNV1F0z-OtCyb6pgnBIZfKwINCCNcekwZrq9E--I5Y",
          "answer": "One thing we’re excited about is delivering customizable GraphQL APIs for the data we are archiving! This will allow developers to access their project’s data more dynamically and allows creative ways to display and work with data that is hard to access without KYVE.",
          "answerTXID": "PIXkUIzjMFps7asgGtqkQLpYYvdPtlnFqaIMFL8sgLE",
          "atBlockheight": 744649,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "answerTo": "9QAp_T36fi-kBIHRl5xdSjMT4KGHyEiWSJs1VLw291c",
          "answer": "You can imagine KYVE as a warehouse. We collect and categorize data to deliver it to our customers better, cheaper, and faster.",
          "answerTXID": "Wxwpl2BhIbyL0QA6ZlIDS0qCuuKsW87sMSUHPywLeCw",
          "atBlockheight": 744649,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "answerTo": "su2ltjJvc62jeVfbw7s-M8yAqDLB1gSlcRL6PkUAfRc",
          "answer": "Each developer and project have their own use cases around the data we’re archiving. However, we’re particularly interested in the cross-chain functionality that KYVE enables! Developers can access data from multiple chains or web3 apps with no problem. We currently see KYVE being used as a safe place to load data from. This helps projects solve scalability problems because they don’t need to store the data themselves.",
          "answerTXID": "cnlLKvxuEFoDpnzevi1IILrggK6AoHywl9bUFKdbxSM",
          "atBlockheight": 744649,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        },
        {
          "answerTo": "ios0UNtRKai8QW_yn1VowKwAztsEf7qtj9iAsUtH0Ss",
          "answer": "The primary use case is incremental snapshots (expanded upon here, https://github.com/solana-labs/solana/issues/17088). When you pull data from KYVE, you can be sure that it’s permanently stored as well as validated. This allows nodes to catch up faster with the current network state to load in historical data safely. Previously they had to rely on centralized snapshots where they were unsure if other parties might have modified the data.",
          "answerTXID": "B08__Q-rK18M6NzxAXoxjds3kSp9en2r6ao7wHHQUIA",
          "atBlockheight": 744663,
          "id": "ZyYQ10XD4nPYyJFobKLhLn45Nabv-Dh30U8ldtC0-jQ"
        }
      ]
}

// uBAtZUaLK8rolhSILgfxG_UGU2GcvawhdQjid3K5oE4

class Amas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
    };
  }

  componentDidMount() {
    //window.location.reload()
    this.loadAmas()
   // this.loadContract()
  }

  /*
  loadContract = async (amaId) => {
    const wallet = JSON.parse(sessionStorage.getItem("arweaveWallet"));
    const input = {"function" : "status", "id": amaId}
    const contract = interactRead(arweave, wallet, amaContractId, input)
    .then((contract => contract))
    return contract
  }
  */

  loadAmas = async () => {
    this.setState( { loadingAmas: true } )
    const amasObj = await readContract(arweave, amaContractId)
    console.log(amasObj)
    this.setState({amas: amasObj["ama"]})
    this.setState( { loadingAmas: false } )
  }

  showQuestionForm = (a) => {
    this.setState({questionToAnswer: a})
    this.setState({showQuestionForm: true})
  }

  showAma = (a) => {
    this.setState({amaToShow: a})
    this.setState({showAma: true})
  }

  goBack = () => {
    window.location.reload()
  }

  

  renderAmas = () => {
    const amaList = []
    const amas = this.state.amas
    for (let i in amas) { 
      let a = amas[i]
      amaList.push(
        <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(a)} variant="link">{a.guests}</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[{a.reward} $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>{a.description}</p>
            <Button className="mb-3" onClick={() => this.showQuestionForm(a)} variant="outline-primary">Ask a question</Button>
            <footer className="ama-id"><code className="mt-2">AMA id: {a.id}</code></footer>
          </Card.Body>
      </Card>
      )
    }
    if (Object.keys(amaList).length === 0) { amaList.push(<p>No AMAs at this time</p>) }
    amaList.push(
      <>
      <h2 className="mt-4">Archived AMAs</h2>
      <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(samAma)} variant="link">Sam Williams</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[10 $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>Arweave CEO & Co-Founder</p>
            <footer className="ama-id"><code className="mt-2">AMA id: r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY</code></footer>
          </Card.Body>
      </Card>
       <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(tateAma)} variant="link">Tate Berenbaum</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[10 $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>Founder @ Verto</p>
            <footer className="ama-id"><code className="mt-2">AMA id: ...</code></footer>
          </Card.Body>
      </Card>
      <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(kyveAma)} variant="link">Fabian Riewe & John Letey</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[10 $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>Founders @ KYVE</p>
            <footer className="ama-id"><code className="mt-2">AMA id: ...</code></footer>
          </Card.Body>
      </Card>
      </>
    )
    return amaList
  }

  render() {
    const amas = this.renderAmas()
    return (
      <div>
        <div className="mt-4">
          <h2><Button variant="link" className="text-decoration-none" onClick={() => this.goBack()}>[ Back ]</Button> Active AMAs</h2>
          {this.state.loadingAmas ? "Loading..." : null}
          <div className="mb-4">
            {this.state.showAma ? <Ama archived={this.state.amaToShow.archived} ama={this.state.amaToShow} /> : null}
            {!this.state.showQuestionForm && !this.state.showAma ? amas : null }
            {this.state.showQuestionForm ? <AmaQuestionForm question={this.state.questionToAnswer}/> : null }
          </div>
        </div>
      </div>
    );
  }
}

export default Amas;
